export enum RepairabilityAttributesTypes {
  RepairabilityIndex = 'repairability_index',
  RepairabilityIndexDatasheet = 'repairability_index_datasheet'
}
